export default function promiseAny<T extends ReadonlyArray<unknown> | []>(
  values: T,
): Promise<Awaited<T[number]>> {
  // eslint-disable-next-line no-restricted-syntax
  return Promise.any(values);
}
